import script from "./tests.vue?vue&type=script&setup=true&lang=js"
export * from "./tests.vue?vue&type=script&setup=true&lang=js"

import "./tests.vue?vue&type=style&index=0&id=2b9bc802&lang=scss&scoped=true"
import "./tests.vue?vue&type=style&index=1&id=2b9bc802&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b9bc802"]])

export default __exports__